import React, { Component, Fragment } from 'react'
import {
  Dialog,
} from 'react-toolbox'
import CSSModules from 'react-css-modules'
import {
  Table,
  TableHead,
  TableRow,
  TableCell
} from 'react-toolbox'
import { Flex } from 'reflexbox'

import styles from './styles.scss'


class RevisionDialog extends Component {
  constructor(props){
    super(props)
    this.state = {
      selected: props.selectedRevisionNumber
    }
  }

  componentDidUpdate(prevProps) {
    const { selectedRevisionNumber } = this.props
    if (prevProps.selectedRevisionNumber !== selectedRevisionNumber)
      this.setState({ selected: selectedRevisionNumber})
  }

  handleCancel = () => {
    const { toggleRevisionDialog, selectedRevisionNumber } = this.props
    toggleRevisionDialog()
    this.setState({
      selected: selectedRevisionNumber
    })
  }

  handleSubmit = () => {
    const { onRevisionChange, toggleRevisionDialog } = this.props
    const { selected } = this.state
    onRevisionChange(selected)
    toggleRevisionDialog()
  }  

  onSelect(idx) {
    this.setState({
        selected: idx
    })
  }

  renderRevisionsTableHeader() {
    return(
      <TableHead>
          <TableCell key={`num`}><div >Revision #</div></TableCell>
          <TableCell key={`created_by`}><div >Created By</div></TableCell>
          <TableCell key={`date_created`}><div >Date Created</div></TableCell>
      </TableHead>
    )
  } 

  renderRevisionsTableRow(){
    const { revisions } = this.props
    const { selected } = this.state
    const revisionNumbers = Object.keys(revisions) 
    revisionNumbers.sort(function(a, b){return b-a}) // descending order
    return revisionNumbers.map (idx => {
      const r = revisions[idx]
      return (
        <TableRow key={idx} selected={selected == r.revisionNumber} onClick={this.onSelect.bind(this, r.revisionNumber)}>
          <TableCell key={`num${idx}`}><div>{r.revisionNumber}</div></TableCell>
          <TableCell key={`name${idx}`}><div>{r.user}</div></TableCell>
          <TableCell key={`created${idx}`}><div>{r.dateCreated}</div></TableCell>
        </TableRow>
      )
    })
  }

  render() {
    const { revisionDialogActive } = this.props
    const { selected } = this.state
    const actions = [
      { label: 'Cancel', onClick: this.handleCancel },
      { label: 'Change Revision', onClick: this.handleSubmit, disabled: selected == null },
    ]
    return (
      <Dialog
        theme={styles}
        active={revisionDialogActive}
        onOverlayClick={this.handleCancel}
        onEscKeyDown={this.handleCancel}
        actions={actions}
        title={'Select Revision'}
        styleName={'revisionDialog'}
      >
        <Flex >
          <Table
            selectable
            multiSelectable={false}
          >
            {this.renderRevisionsTableHeader()}
            {this.renderRevisionsTableRow()}
          </Table>
        </Flex>
    </Dialog>
    )
  }
}

export default CSSModules(RevisionDialog, styles)
